export const DEMO_USER_EMAIL = 'demouser@histowiz.com';
export const DEMO_USER_PASSWORD = 'tree-swift-triangle';
